import React from 'react';
const Map = () => {
    return (
        <iframe title="mapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3404.8080219469125!2d-64.18904538468068!3d-31.419415003542813!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9432a2846f1efd9d%3A0x6b5dbbdea858fcf8!2sUniversidad%20Cat%C3%B3lica%20de%20C%C3%B3rdoba%20(U.C.C.)%20%E2%80%93%20Jesuitas%20%5BEdificio%20Centro%5D!5e0!3m2!1ses!2sar!4v1622645653039!5m2!1ses!2sar" width="100%" height="300" loading="lazy" className="border-0"></iframe>
    )
}

export default Map
